exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n/* make sure to keep these in sync with other constants,\r\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\r\n\r\n/* layout contants from `layout-constants.js` */\r\n\r\n.user-avatar_user-thumbnail_IwOnc {\r\n    width: 2rem;\r\n    height: 2rem;\r\n    border-radius: calc(0.5rem / 2);\r\n    vertical-align: middle;\r\n    box-shadow: 0 0 0 1px var(--ui-black-transparent);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"user-thumbnail": "user-avatar_user-thumbnail_IwOnc",
	"userThumbnail": "user-avatar_user-thumbnail_IwOnc"
};